import Btn from '../elements/Btn';
import Checklist from '../elements/Checklist';
import Hero from '../elements/Hero'
import Title from '../elements/Title'
import HeroBanner from '../img/whyus.png';
import BookingImage from "../img/booking.png";
import BookingImage1 from "../img/booking1.png";
import BookingImage3 from "../img/booking3.png";
import TriImage from '../elements/TriImage';
import TrustedPartners from '../elements/TrustedPartners';
import AdditionalServices from "../elements/AdditionalServices";
import HappyCustomers from '../elements/HappyCustomers';
import ExploreAll from '../elements/ExploreAll';
import Newsletter from '../elements/Newsletter';
import Footer from '../elements/Footer';
import FreeQuote from '../elements/FreeQuote';
import QuickServices from '../elements/QuickServices';
import user from '../img/testimonial.png';
import PackagePlan from '../elements/PackagePlan';
import Packaging from '../elements/Packaging';
import movie from '../video/movie.mp4';
import packvideo from '../img/whyvideo.png';
import hourly from '../img/labor/hourly.png';
import loading from '../img/labor/loading.png';
import hourlyIcon from '../img/labor/hourlyIcon.png';
import loadingIcon from '../img/labor/loadingIcon.png';
import catering from '../img/whyus/catering.png';
import commited from '../img/whyus/commited.png';
import dedicated from '../img/whyus/dedicated.png';
import packingIcon from '../img/labor/packingIcon.png';

export default function Whyus() {
    const service = [
        {
            title: "Hourly Labor Services",
            des: "When you need an extra set of hands—or an entire team—to complete a home or office project, Exquisite Moves is here to help. We’ll take care of all the heavy lifting, re-arranging, and a lot more so you can sit back and relax!"
        },
        {
            title: "Professional Nationwide Packing Services",
            des: "When you plan a local or long-distance move, packing up your entire home or business can be a tiring and time-consuming process. Eliminate the stress of having to do it all on your own with Exquisite Moves!"
        },
        {
            title: "Furniture Moving & Rearrangement",
            des: "At Exquisite Moves, we have the experience and professional training to properly handle your most cherished furniture. From heavy desks and office equipment to antique furniture and home décor..."
        },
        {
            title: "Furniture Moving & Rearrangement",
            des: "At Exquisite Moves, we have the experience and professional training to properly handle your most cherished furniture. From heavy desks and office equipment to antique furniture and home décor..."
        },
    ]

    const customers = [
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },

    ]

    return <>
        <Hero bg={HeroBanner} >
            <div className='pt-3 pt-sm-4 pt-lg-5 bannerTri' >
                <div className='row align-items-end' >
                    <div className='col-lg-6 pb-3 pb-lg-5 mt-3' >

                        <div className='banner_content py-0 pt-4' >
                            <Title mainClass="text-start"
                                titleclass="lg text-white mb-2 text-center text-lg-start"
                                desclass=" text-center text-lg-start mt-3 mb-2"
                                title={<>Why Choose
                                    Exquisite Moves?</>}
                                des="Premier Junk Removal & Moving Services From Premier Professionals!" />
                            <Checklist
                                list={["Moving Services", "Junk Removal", "Donation", "Labour"]}
                                class="my-4 text-white ps-0 ps-sm-4 ps-lg-0" col="col-sm-6"
                                liststyle="normal" />
                            <Btn class="mb-0 mb-lg-4 m-lg-0 m-auto d-table"
                                arrow={true}
                                wave={true}
                                href="#"
                            >Contact Us</Btn>
                        </div>
                    </div>
                    <div className='col-lg-6 ps-lg-5' >
                        <TriImage mainclass="mt-3"
                            img1={BookingImage1}
                            img2={BookingImage}
                            img3={BookingImage3}
                        />
                    </div>
                </div>
            </div>
        </Hero>
        <TrustedPartners />
        <div className='delivaryAffordable py-3 py-sm-5' >
            <div className='container' >
                <Title mainClass="mb-3"
                    subheading="why Exquisite Moves ?"
                    subclass="border-none text-center text-uppercase"
                    titleclass="md heading text-dark text-center  mb-3 mt-0 mt-lg-3"
                    desclass="mb-0 text-center w-50 m-auto d-table"
                    title={<>What Makes Us Different?</>}
                    des="When it comes to moving into a new home or getting rid of some unwanted items around your house, you have many options. We understand this. Moving companies, dumpsters, truck rentals—finding an option isn’t the hard part. However, when seeking someone to help you with services that involve your home or property, you want to make sure that whoever you hire is honest, reliable, and trustworthy."
                />

                <div className='pcVid' >
                    <video poster={packvideo} controls >
                        <source src={movie} type="video/mp4" />
                        <source src={movie} type="video/ogg" />
                    </video>
                </div>
            </div>
        </div>
        <div className="bg_wrapper mt-3 mt-lg-5 ">
            <div className="container position-relative">
                <div className="joning" >
                    <svg width="793" height="1311" viewBox="0 0 793 1311" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M72.6337 1C51.2533 30.5 7.99874 91.5 3.14756 153C-0.204875 195.5 -0.467888 272.627 29.3871 339.5C108.296 516.252 344.261 462 492.466 484.5C596.403 500.279 665.585 522.863 727.163 600C794.22 684 806.788 780.667 776.241 883.5C736.882 1016 635.811 1074.5 517.247 1150C391.946 1229.79 72.1477 1309.5 72.1477 1309.5" stroke="#AFC4D6" stroke-width="2" stroke-dasharray="8 8" />
                    </svg>
                </div>
                <div className="serviceSec pt-4 pb-5 mb-lg-5" >
                    <div className="row align-items-center " >
                        <div className="col-xl-6 col-lg-7 pe-lg-4" >
                            <div className='whySec' >
                                <div className='titleNo bg-darkblue' >1</div>
                                <div className='titleSec_outer ps-lg-4 ms-lg-2 ps-3 ps-lg-0' >
                                    <Title mainClass="mb-3  "
                                        titleclass="lg heading text-dark text-start mb-2 mb-lg-4"
                                        desclass="mb-0"
                                        title={<>Catering To Your Needs</>}
                                        des="Every home is unique, and every person has their own specific circumstances and expectations. That’s why our team is trained to understand exactly what our clients want prior to beginning our work. Moving can be one of the most stressful events in a person’s life—but it shouldn’t be. Regardless of the reason for your move, you can count on our team of professionally trained movers to handle it with precision and care."
                                    />
                                    <Btn class="mt-0  mt-md-3"
                                        arrow={true}
                                        wave={true}
                                        href="#"
                                    >Book Now</Btn>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-5 pt-3 pt-lg-0 ps-xl-5" >
                            <img src={catering} className="img-fluid m-auto d-table" alt="services" />
                        </div>
                    </div>
                </div>

                <div className="serviceSec pt-4 pb-5 mb-lg-5" >
                    <div className="row align-items-center flex-lg-row-reverse " >
                        <div className="col-xl-6 col-lg-7 ps-lg-4" >
                            <div className='whySec' >
                                <div className='titleNo bg-orange' >2</div>
                                <div className='titleSec_outer ps-lg-4 ms-lg-2 ps-3 ps-lg-0' >
                                    <Title mainClass="mb-3 "
                                        titleclass="lg heading text-dark text-start mb-4"
                                        desclass="mb-0"
                                        title={<>Committed To Our Community</>}
                                        des="We’ve been in business for a while, and we plan to be here long into the future. That’s a big reason why we are committed to the communities we serve. It’s integral for us to be more than just a moving company or a junk removal service. We want to make people in the communities we serve happy in the process. We are proud to be partnered with several local charities and non-profits including Goodwill."
                                    />
                                    <Btn class="mt-0  mt-md-3"
                                        arrow={true}
                                        wave={true}
                                        href="#"
                                    >Book Now</Btn>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-5 pt-3 pt-lg-0 pe-xl-5" >
                            <img src={commited} className="m-auto d-table img-fluid" alt="services" />
                        </div>
                    </div>
                </div>

                <div className="serviceSec pt-4 pb-5 mb-lg-5 position-relative" >
                    <div class="svgWrap"><svg width="624" height="678" viewBox="0 0 624 678" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.1" filter="url(#filter0_f_1312_10196)"><path fill-rule="evenodd" clip-rule="evenodd" d="M481.209 352.001C470.173 386.669 444.914 413.19 422.037 441.462C402.326 465.821 381.32 487.535 356.292 506.373C328.414 527.356 302.122 556.558 267.273 557.946C232.311 559.339 202.951 533.407 174.067 513.634C146.911 495.044 127.575 469.427 104.166 446.286C72.1264 414.612 16.8334 396.642 10.5661 352.001C4.50732 308.845 48.4887 275.35 75.3531 241.061C99.1624 210.671 125.738 183.755 158.438 163.262C192.015 142.219 228.082 115.019 267.273 120.785C306.401 126.54 323.038 176.499 359.088 192.779C401.116 211.758 463.755 185.58 491.836 222.192C518.703 257.222 494.604 309.919 481.209 352.001Z" fill="#FF9900"></path></g><defs><filter id="filter0_f_1312_10196" x="-110" y="0" width="734" height="678" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feGaussianBlur stdDeviation="60" result="effect1_foregroundBlur_1312_10196"></feGaussianBlur></filter></defs></svg></div>
                    <div className="row align-items-center " >
                        <div className="col-xl-6 col-lg-7" >
                            <div className='whySec' >
                                <div className='titleNo bg-darkblue' >3</div>
                                <div className='titleSec_outer ps-lg-4 ms-lg-2 ps-3 ps-lg-0' >
                                    <Title mainClass="mb-3 "
                                        titleclass="lg heading text-dark text-start mb-4"
                                        desclass="mb-0"
                                        title={<>Dedicated to the Environment
                                        </>}
                                        des="Our junk removal services don’t just rid your home of clutter and unwanted belongings, they help the environment as well. If we are unable to donate your items, we take every measure possible to recycle or dispose of them in the most eco-friendly way possible. We are proud that over 70% of the items we remove from clients' homes are recycled or responsibly discarded. Help us make the world a slightly better place—one piece of junk at a time."
                                    />
                                    <Btn class="mt-0  mt-md-3"
                                        arrow={true}
                                        wave={true}
                                        href="#"
                                    >Book Now</Btn>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-5 pt-3 pt-lg-0 ps-xl-5" >
                            <img src={dedicated} className="m-auto d-table img-fluid" alt="services" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Packaging />  
        <AdditionalServices title="Beyond Junk Removal & Moving" des="When you hire the Exquisite Moves, you get more than just a simple moving company. We offer an extensive array of hourly labor services for an assortment of home needs. Our hourly services mean you only pay for what you need—and never anything more." data={service} />
        <HappyCustomers customers={customers} />
        <QuickServices />
        <FreeQuote />
        <Newsletter />
        <Footer />
    </>
}